
import { defineComponent } from "vue";
export default defineComponent({
  name: "PdfRowBase",
  components: {
  },
});
